import * as React from 'react';
import { useSelector } from 'react-redux';
import { trackShowPhone } from './tracking';
import { BuilderChatPhone } from '../../components/BuilderChatPhone';
import { getGaLabel, getNewbuildingId } from '../../selectors/newbuilding';
import { IBuilder } from '../../types/newbuilding/builder';
import { ISeller } from '../../types/newbuilding/seller';
import { formatNumber, phoneToString } from '../../utils/phoneToString';
import { BuilderChatDynamicPhone } from '../BuilderChatDynamicPhone';

interface ICallButtonProps {
  onClick: () => void;
}

interface IBuilderChatCallContainerProps {
  sellers: ISeller[];
  builders: IBuilder[];
  CallButtonComponent: React.ComponentType<ICallButtonProps>;
}

export const BuilderChatCallContainer = ({
  sellers,
  builders,
  CallButtonComponent,
}: IBuilderChatCallContainerProps) => {
  const [isPhoneShown, setIsPhoneShown] = React.useState(false);

  const gaLabel = useSelector(getGaLabel);
  const newbuildingId = useSelector(getNewbuildingId);

  const contact: IBuilder | ISeller = React.useMemo(() => {
    // Из библиотеки чата ожидается только один контакт
    return [...sellers, ...builders][0];
  }, [sellers, builders]);

  const notFormattedPhone = React.useMemo(() => phoneToString(contact.phone), [contact]);
  const formattedPhone = React.useMemo(() => formatNumber(contact.phone), [contact]);

  const onClick = React.useCallback(() => {
    trackShowPhone({
      gaLabel,
      newbuildingId,
      isBuilder: builders.length > 0,
    });
    setIsPhoneShown(true);
  }, [builders.length, gaLabel, newbuildingId]);

  if (isPhoneShown && contact.dynamicCalltracking?.siteBlockId) {
    return (
      <BuilderChatDynamicPhone
        siteBlockId={contact.dynamicCalltracking.siteBlockId}
        notFormattedPhone={notFormattedPhone}
        phoneNumber={formattedPhone}
      />
    );
  }

  if (isPhoneShown) {
    return <BuilderChatPhone phone={formattedPhone} />;
  }

  return <CallButtonComponent onClick={onClick} />;
};
